import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import colors from '../../styles/colors';
import { media } from '../../util/MediaQuery';

const LayoutRoot = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  background: ${colors.background};

  ${media.desktop`
    flex-direction: row;
    min-height: 100vh;
  `}
`;

const ImageSection = styled.div`
  width: 100%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${colors.white};
  min-height: 200px;
  max-height: 40vh;

  ${media.desktop`
    position: fixed;
    left: 0;
    top: 0;
    width: 50%;
    height: 100vh;
    max-height: 100vh;
    z-index: 0;
  `}
`;

const ScreenImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;

  ${media.desktop`
    height: 100vh;
    object-fit: cover;
  `}
`;

const FormSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding: 24px 20px;
  overflow-y: auto;
  background: ${colors.background};

  ${media.desktop`
    margin-left: 50%;
    width: 50%;
    min-height: 100vh;
    padding: 40px 48px;
    position: relative;
    z-index: 1;
  `}
`;

const ProgressContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 24px;
`;

const ProgressSegment = styled.div`
  height: 4px;
  flex: 1;
  max-width: 80px;
  background: ${(p) => (p.filled ? colors.seaGreen : colors.grey5)};
  border-radius: 2px;
`;

const SignInLink = styled(Link)`
  font-size: 1.2rem;
  color: ${colors.seaGreen};
  margin-top: 24px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
`;

const TOTAL_STEPS = 6;

export default function NewAccountScreenLayout({
  stepNumber,
  screenImageSrc,
  title,
  children,
  showSignInLink = true,
  footer,
}) {
  return (
    <LayoutRoot>
      <ImageSection>
        <ScreenImage src={screenImageSrc} alt="" />
      </ImageSection>
      <FormSection>
        <ProgressContainer>
          {Array.from({ length: TOTAL_STEPS }, (_, i) => (
            <ProgressSegment key={i} filled={i + 1 <= stepNumber} />
          ))}
        </ProgressContainer>
        {title && (
          <h1
            style={{
              fontSize: '1.75rem',
              fontWeight: 600,
              color: colors.lightBlack,
              marginBottom: '24px',
            }}
          >
            {title}
          </h1>
        )}
        {children}
        {footer && <ButtonRow>{footer}</ButtonRow>}
        {showSignInLink && (
          <SignInLink to="/login">Already have an account? Sign in</SignInLink>
        )}
      </FormSection>
    </LayoutRoot>
  );
}
